import React, { useEffect, useMemo } from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { DeviceInterface } from "src/store/callrecorder/devicesSlice";
import { fetchDevices } from "src/actions/callrecorder/devicesActions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";
import OptionalLink from "src/componets/OptionalLink";

import { Tag } from "antd";

interface ListTableInterface {
  filterParams: object;
  limit?: number;
}

const _ListTable = ({ filterParams, limit = 25 }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.devices.ids);
  const entities = useAppSelector(state => state.callrecorder.devices.entities);
  const count = useAppSelector(state => state.callrecorder.devices.count);
  const data = ids ? ids.map(id => entities[id]) : [];

  const params = useMemo(() => ({
    limit,
    ...filterParams
  }), [limit, filterParams]);

  useEffect(() => {
    dispatch(fetchDevices(params));
  }, [params, dispatch]);

  const columns: ColumnsType<DeviceInterface> = [
    {
      key: 'id',
      title: 'ID',
      render: (_, { id, url }) => (
        <OptionalLink link={url}>
          {`#${id}`}
        </OptionalLink>
      ),
      width: 60
    },

    {
      key: 'vendor',
      title: 'Vendor',
      render: (_, { vendor }) => <small>{vendor}</small>,
      width: 100
    },

    {
      key: 'country_code',
      title: 'Country',
      render: (_, { country_code }) => <small>{country_code || '—'}</small>,
      width: 40
    },

    {
      key: 'language',
      title: 'Lang',
      render: (_, { language }) => <small>{language || '—'}</small>,
      width: 40
    },

    {
      key: 'sign_in_count',
      title: 'Sign-ins',
      render: (_, { sign_in_count }) => <small>{sign_in_count}</small>,
      width: 40
    },

    {
      key: 'is_deleted',
      title: 'Deleted',
      render: (_, { is_deleted }) => is_deleted ? <Tag color="error">yes</Tag> : <Tag color="default">no</Tag>,
      width: 70
    },

    {
      key: 'current_sign_in_ip',
      title: 'Current IP',
      render: (_, { current_sign_in_ip }) => current_sign_in_ip ? <small>{current_sign_in_ip}</small> : '—',
      width: 110
    },

    {
      key: 'last_sign_in_ip',
      title: 'Last IP',
      render: (_, { last_sign_in_ip }) => last_sign_in_ip ? <small>{last_sign_in_ip}</small> : '—',
      width: 110
    },

    {
      key: 'reg_sign_in_ip',
      title: 'Reg IP',
      render: (_, { reg_sign_in_ip }) => reg_sign_in_ip ? <small>{reg_sign_in_ip}</small> : '—',
      width: 110
    },

    {
      key: 'current_sign_in_at',
      title: 'Last Sign-in',
      render: (_, { current_sign_in_at }) => current_sign_in_at ? <small>{formattedDate(current_sign_in_at).dateTime}</small> : '—',
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created',
      render: (_, { created_at }) => <small>{formattedDate(created_at).dateTime}</small>,
      width: 125
    },
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
